import { Component, EventEmitter, Input, Output } from '@angular/core'
import { EbCartItemHeaderComponent } from '../../../cart/components/cart-item-header/eb-cart-item-header.component'

@Component({
    selector: 'eb-favorites-item-header',
    templateUrl: './eb-favorites-item-header.component.html',
    styleUrls: ['./eb-favorites-item-header.component.scss'],
    standalone: false
})
export class EbFavoritesItemHeaderComponent extends EbCartItemHeaderComponent {
  @Input() isAllSelected = false
  @Output() allItemsSelected = new EventEmitter()

  onItemSelectChange(isChecked: boolean) {
    this.allItemsSelected.emit(isChecked)
  }
}
